import { Location } from "@angular/common";
import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { finalize } from "rxjs/operators";
import { ITimeEntry } from "../models/ITimeEntry";
import { TimetrackingService } from "../timetracking.service";

@Component({
  selector: "app-time-delete",
  templateUrl: "./time-delete.component.html",
  styleUrls: ["./time-delete.component.scss"],
})
export class TimeDeleteComponent {
  private savingBehaviorSubject = new BehaviorSubject<boolean>(false);

  saving$ = this.savingBehaviorSubject.asObservable();

  timeEntry: ITimeEntry;
  hours = 0;
  minutes = 0;

  constructor(
    activatedRoute: ActivatedRoute,
    private location: Location,
    private timeTrackingService: TimetrackingService
  ) {
    const entryId = parseInt(activatedRoute.snapshot.params.entryId, 10);
    timeTrackingService.getTimeEntry(entryId).subscribe((timeEntry) => {
      this.timeEntry = timeEntry;
      this.hours = Math.floor(timeEntry.timeSpentMinutes / 60);
      this.minutes = timeEntry.timeSpentMinutes % 60;
    });
  }
  delete() {
    this.savingBehaviorSubject.next(true);
    this.timeTrackingService
      .deleteTimeEntry(this.timeEntry.id)
      .subscribe(() => {
        this.goBack();
      });
  }
  cancel() {
    this.goBack();
  }
  goBack() {
    this.location.back();
  }
}
